import { create } from 'zustand'
import type { WelcomeTransitionStore } from '@/stores/welcomeTransition.types'

let activeCover: Promise<void> | null = null
let resolveActiveCover: (() => void) | null = null
let activeReveal: Promise<void> | null = null
let resolveActiveReveal: (() => void) | null = null

function resolveCover() {
  resolveActiveCover?.()
  resolveActiveCover = null
}

function resolveReveal() {
  resolveActiveReveal?.()
  resolveActiveReveal = null
}

export const useWelcomeTransition = create<WelcomeTransitionStore>()(
  (set, get) => ({
    phase: 'idle',

    cover() {
      if (activeCover) return activeCover

      set({ phase: 'covering' })

      activeCover = new Promise<void>((resolve) => {
        resolveActiveCover = resolve
      })

      return activeCover
    },

    markCovered() {
      if (get().phase !== 'covering') return

      set({ phase: 'covered' })
      resolveCover()
    },

    reveal() {
      if (activeReveal) return activeReveal

      if (get().phase !== 'covered') return Promise.resolve()

      set({ phase: 'revealing' })

      activeReveal = new Promise<void>((resolve) => {
        resolveActiveReveal = resolve
      })

      return activeReveal
    },

    reset() {
      resolveCover()
      resolveReveal()
      activeCover = null
      activeReveal = null
      set({ phase: 'idle' })
    },
  })
)
